import { useState } from "react";
import AllTransactions from "./AllTransactions";
import DepositTransactions from "./DepositTransactions";
import WithdrawalTransactions from "./WithdrawalTransactions";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function WalletTransactions({ selectedWallet }) {
    const [activeTab, setActiveTab] = useState("all");

    return (
        <div className="w-full pb-6">
            {/* Transaction Tabs */}
            <div className="border-b border-gray-200 dark:border-gray-700 mb-4">
                <nav className="-mb-px flex justify-center space-x-8">
                    {[
                        { name: "All", key: "all" },
                        { name: "Deposits", key: "deposits" },
                        { name: "Withdrawals", key: "withdrawals" },
                    ].map((tab) => (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            className={classNames(
                                tab.key === activeTab
                                    ? "border-primary text-primary font-semibold"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300",
                                "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors"
                            )}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            </div>

            {/* Transactions Content */}
            {activeTab === "all" && <AllTransactions selectedWallet={selectedWallet} />}
            {activeTab === "deposits" && <DepositTransactions selectedWallet={selectedWallet} />}
            {activeTab === "withdrawals" && <WithdrawalTransactions selectedWallet={selectedWallet} />}
        </div>
    );
}
